import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "kontaktArt_container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kontakt_container", { fixiert: _ctx.sticky }]),
    style: {"width":"1140px","margin-left":"calc((100vw - 1140px) / 2)"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["content_container", { aktiv: _ctx.isTelefonAktiv }])
      }, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle_telefon && _ctx.toggle_telefon(...args))),
          class: _normalizeClass(["contact-icon contact-icon_telefon", { links: _ctx.isTelefonAktiv }])
        }, " ", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["contact-text", { offen: _ctx.isTelefonAktiv }])
        }, [
          _createElementVNode("a", {
            tabindex: "-1",
            href: 'tel:' + _ctx.telefonNummer
          }, _toDisplayString(_ctx.telefonNummer), 9, _hoisted_2)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content_container", { aktiv: _ctx.isMailAktiv }])
      }, [
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle_mail && _ctx.toggle_mail(...args))),
          class: _normalizeClass(["contact-icon contact-icon_mail", { links: _ctx.isMailAktiv }])
        }, " ", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["contact-text", { offen: _ctx.isMailAktiv }])
        }, [
          _createElementVNode("a", {
            tabindex: "-1",
            href: 'mailto:' + _ctx.emailAdresse
          }, _toDisplayString(_ctx.emailAdresse), 9, _hoisted_3)
        ], 2)
      ], 2)
    ])
  ], 2))
}